import React, { useContext } from 'react';
import styled from '@emotion/styled';
import Tooltip from '@atlaskit/tooltip';
import Button from '@atlaskit/button';
import EmptyState from '@atlaskit/empty-state';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import { GlobalContext } from '../../shared-components/common/GlobalContext';
import { DTOGroupSearchResultItem, UNKNOWN_GROUP_GROUPNAME_PLACEHOLDER_DTO } from '../../generated-common';
import Spinner from '@atlaskit/spinner';
import PeopleIcon from '@atlaskit/icon/glyph/people';
import { token } from '@atlaskit/tokens';

const GroupWrapper = styled.div`
  margin-top: 5px;
`;

const Group = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
  &:hover {
    background-color: ${token('color.background.neutral.subtle.pressed', '#efefef')};
  }
`;
const GroupIconAndNameWrapper = styled.div`
  display: flex;
  align-items: center;
`;
const GroupIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
interface GroupNameProps {
  color: string;
}
const GroupName = styled.div<GroupNameProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  color: ${(props) => props.color};
`;

const GroupIconRound = styled.div`
  max-width: 30px;
  min-width: 30px;
  width: 30px;
  max-height: 30px;
  min-height: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${token('color.background.accent.blue.subtlest.hovered', '#e8e9eb')};
  display: flex;
  align-items: center;
  justify-content: center;
`;
const GroupButton = styled.div``;

export const PermissionEditorSetAndGetPermissionsGroupList = ({
  isFetching,
  isMutating,
  groups,
  onDeleteClick,
}: {
  isFetching: boolean;
  isMutating: boolean;
  groups: DTOGroupSearchResultItem[];
  onDeleteClick: (group: string) => void;
}) => {
  const { t } = useContext(GlobalContext);

  return (
    <GroupWrapper>
      <div style={{ height: '20px', minHeight: '20px', maxHeight: '20px' }}>{(isFetching || isMutating) && <Spinner size="small" />}</div>
      {!isFetching && !isMutating && (!groups || groups.length === 0) && (
        <>
          <EmptyState header={t('editPermissionsPage.emptyMessage.groupTitle')} description={t('editPermissionsPage.emptyMessage.groupDescription')} />
        </>
      )}
      {groups && groups.length > 0 && (
        <>
          {groups.map((g, ind) => (
            <Group key={ind}>
              <GroupIconAndNameWrapper>
                <GroupIcon>
                  <GroupIconRound>
                    <PeopleIcon label="group" primaryColor={token('color.text.accent.blue.bolder', '#253858')} />
                  </GroupIconRound>
                </GroupIcon>
                <GroupName color={isMutating || isFetching ? token('color.text.subtlest', '#ccc') : token('color.text.accent.blue.bolder', '#253858')}>
                  {g.groupName === UNKNOWN_GROUP_GROUPNAME_PLACEHOLDER_DTO ? <span style={{ color: token('color.text.subtlest', '#ccc'), fontStyle: 'italic' }}>unknown group</span> : g.groupName}
                </GroupName>
              </GroupIconAndNameWrapper>
              <GroupButton>
                <Tooltip content={t('global.permission.remove')}>
                  <Button
                    isDisabled={isMutating || isFetching}
                    appearance="subtle"
                    onClick={() => onDeleteClick(g.groupId)}
                    iconBefore={<EditorRemoveIcon label="delete" primaryColor={isMutating ? token('color.text.disabled', '#ccc') : token('color.text.accent.blue.bolder', '#253858')} />}
                  />
                </Tooltip>
              </GroupButton>
            </Group>
          ))}
        </>
      )}
    </GroupWrapper>
  );
};
